<template>
  <div class="mw-panel worktime">
    <mw-dialog ref="dialog" size="large_large" :title="title"  :before-close="handleClose">
      <div class="mw-toolbar">
        <el-button @click="handleClose" type="primary"><i class="fa fa-mail-reply" type="primary"></i>关闭</el-button>
        <el-button @click="save" type="primary"><i class="fa fa-file-text" type="primary"></i>保存</el-button>
        <el-button type="info" @click="helpnotes" class="pull-right" style="margin-top: 8px;">
          <i class="fa fa-question"></i>帮助
        </el-button>
      </div>
      <div class="mw-toolbar__body">
        <el-form label-width="100px"  style="width:90%;" class="mw-form"  :model="form" ref="form">
          <el-col :span="24">
            <el-form-item v-show="false">
              <el-input v-model="form.id"></el-input>
            </el-form-item>
            <el-form-item label="所属单位">
              <el-input v-model="form.unitName" readonly style="width:75%"></el-input>
              <el-button type="primary" @click="showUnit">选择</el-button>
            </el-form-item>
            <el-form-item label="单位ID" v-show="false">
              <el-input v-model="form.unitId"></el-input>
            </el-form-item>
            <el-form-item label="上午工作时间">
            <el-time-select
                placeholder="起始时间"
                v-model="form.amStartTime"
                :picker-options="{
                  start: '00:00',
                  step: '00:15',
                  end: '12:00'
                }">
              </el-time-select>
              至
              <el-time-select
                placeholder="结束时间"
                v-model="form.amEndTime"
                :picker-options="{
                  start: '00:00',
                  step: '00:15',
                  end: '12:00',
                  minTime: form.amStartTime
                }">
              </el-time-select>
            </el-form-item>
            <el-form-item label="下午工作时间">
              <el-time-select
                  placeholder="起始时间"
                  v-model="form.pmStartTime"
                  :picker-options="{
                    start: '12:00',
                    step: '00:15',
                    end: '24:00'
                  }">
                </el-time-select>
                至
                <el-time-select
                  placeholder="结束时间"
                  v-model="form.pmEndTime"
                  :picker-options="{
                    start: '12:00',
                    step: '00:15',
                    end: '24:00',
                    minTime: form.pmStartTime
                  }">
                </el-time-select>
            </el-form-item>
            <el-form-item label="工作日">
              <el-checkbox-group v-model="form.workdaysList" :min="1">
                <el-checkbox v-for="workday in workdayOptions" :label="workday.id" :key="workday.id">{{workday.name}}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <!-- <el-form-item label="节假日">
              <el-input type="textarea"
                          :rows="2" v-model="form.holidays" readonly></el-input>
              <el-date-picker
                v-model="form.aholiday"
                type="date"
                format="MM-dd"
                value-format="MM-dd"
                :picker-options="pickerDateRange"
                style="width:25%">
              </el-date-picker>
              <el-button type="primary" @click="addDay('holiday')">增加</el-button>
              <el-select v-model="form.dholidayIndex" placeholder="请选择" style="width:25%">
              <el-option
                v-for="(item, index) in form.holidayOptions"
                :key="item"
                :label="item"
                :value="index">
              </el-option>
              </el-select>
              <el-button type="primary" @click="delDay('holiday')">移除</el-button>
            </el-form-item>
            <el-form-item label="休息日上班">
              <el-input type="textarea"
                          :rows="2" v-model="form.restdays" readonly></el-input>
              <el-date-picker
                v-model="form.arestday"
                type="date"
                format="MM-dd"
                value-format="MM-dd"
                :picker-options="pickerDateRange"
                style="width:25%">
              </el-date-picker>
              <el-button type="primary" @click="addDay('restday')">增加</el-button>
              <el-select v-model="form.drestdayIndex" placeholder="请选择" style="width:25%">
              <el-option
                v-for="(item, index) in form.restdayOptions"
                :key="item"
                :label="item"
                :value="index">
              </el-option>
              </el-select>
              <el-button type="primary" @click="delDay('restday')">移除</el-button>
            </el-form-item> -->
            <el-form-item label="是否默认" v-show="false">
              <el-input v-model="form.isDefault"></el-input>
            </el-form-item>
          </el-col>
        </el-form>
        <div style="clear: both;"></div>
        <worktime-preview ref="worktimePreview" @setSpecialDay='setSpecialDay' :formData="form" :isNew="isNew"></worktime-preview>
      </div>
    </mw-dialog>
    <toolbar-table :layout="layout" ref="toolbarTable">
    </toolbar-table>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import worktimePreview from './worktimePreview'
export default{
  data(){
    let me = this;
    //获得当前年份4位年
    var currentYear=new Date().getFullYear();
    //本年第一天
    var currentYearFirstTime=new Date(currentYear,0,1).getTime();
    //本年最后
    var currentYearLastTime=new Date(currentYear,11,31).getTime();
    return {
      layout:[],
      form:{
          id:'',
          unitId:'',
          unitName:'',
          amStartTime:'09:00',
          amEndTime:'12:00',
          pmStartTime:'13:30',
          pmEndTime:'17:30',
          workdaysList:['1','2','3','4','5'],
          holidays:'',
          restdays:'',
          aholiday:'',
          dholidayIndex:'',
          holidayOptions:[],
          arestday:'',
          drestdayIndex:'',
          restdayOptions:[],
          isDefault:0
      },
      isNew: false,
      workdayOptions:[{name:'星期日', id:'0'},{name:'星期一', id:'1'},{name:'星期二', id:'2'},{name:'星期三', id:'3'},{name:'星期四', id:'4'},{name:'星期五', id:'5'},{name:'星期六', id:'6'}],
      title:'工作时间',
      defaultParams:{deep:true,isContainSelf:true,parentId:""},
      pickerDateRange:{
          disabledDate:(date)=>{
             var time = date.getTime();
             return time<currentYearFirstTime || time>currentYearLastTime;
          }
      }
    };
  },
  mounted(){
    let me = this;
    var isSysAdmin = this.isSysAdmin();
    var sysAdminShowAllUnit = true;
    if(window.$Env && window.$Env.dataManagementByUnit){
      sysAdminShowAllUnit = false;
    }
    if((this.userInfo.developer || isSysAdmin) && sysAdminShowAllUnit){
      this.defaultParams.parentId = this.userInfo.owner||"";;
    }else{
      if(this.$store.getters.curUnit && this.$store.getters.curUnit.length > 0){
        this.defaultParams.parentId = this.$store.getters.curUnit[0].id;
      }
    }
    me.layout=[[
      {
        span: 0,
        type: 'menu',
        api: 'data.listWorkTime',
        defaultParams:{titleColName:'unitName',unitId:me.defaultParams.parentId},
        columns: [
          {type: 'selection'},
          {slot:{type:'href',func:me.edit},prop: 'unitName', label: '单位名称'},
          {prop: 'amTime', label: '上午上班时间',width:'120'},
          {prop: 'pmTime', label: '下午上班时间',width:'120'},
          {prop: 'workdays', label: '工作日', formatter:me.workdayFormatter, width:'350'},
          // {prop: 'holidays', label: '节假日', tooltip: true},
          // {prop: 'restdays', label: '休息日上班', tooltip: true},
          {prop: 'isDefault', label: '是否默认',width:'90', formatter:me.defaultFlagFormatter}
        ]
      },{
        span: 10, type: 'button', items: [
          {label: '新增',icon:"fa fa-plus-square", func: me.add},
          {label: '删除',icon:"fa fa-trash-o fa-fw", func: me.delete},
          {label: '设置为默认',icon:"fa fa-cog", func: me.setDefault},
        ]
      }, {
        span:5,offset:7, type: 'searchText',name:'titleLike'
      }
    ]];

    me.$nextTick(function(){
        $(me.$el).find(".el-row").append('<button id="showhelp" style="float:right;margin-top:8px;" type="button" class="el-button el-button--info"><span><i class="fa fa-question"></i><span>帮助</span></span></button>');
        $("#showhelp").click(function(){
          me.helpnotesview();
        })
    })

  },
  computed:{
     ...mapGetters([
          'userInfo',
          'expUser'
      ])
  },
  methods:{
    defaultFlagFormatter(data){
      var me = this;
      return data.isDefault=='1'?'是':'否';
    },
    workdayFormatter(data){
      var v = data.workdays;
      return v.replace('0','星期日').replace('1','星期一').replace('2','星期二').replace('3','星期三').replace('4','星期四').replace('5','星期五').replace('6','星期六');
    },
    showUnit(){
      var me = this,selectNode='';
      if(me.form.unitId){
        selectNode=me.form.unitId;
      }
      PF.show('tree',{url: this.mwUrl("/api/org/getUnitTreeContainSelf"), defaultParams:me.defaultParams,selectNode:selectNode,search: false,multiple:false,singleLeaf:false,clearBtn:true},function(res){
        me.form.unitId = res.id;
        me.form.unitName = res.name;
      });
    },
    isSysAdmin(){
        if(this.userInfo.roleNames && this.userInfo.roleNames.indexOf("系统管理员") !=-1){
          return true;
        }
        return false;
      },
    addDay(type){
      var me = this;
      if(type=='holiday'){
        var aday = me.form.aholiday;
        var days = me.form.holidays;
        var optiondays = me.form.holidayOptions;
        if(!days){
            days = aday;
            optiondays=[aday];
        }else if(days.indexOf(aday)==-1){
            optiondays.push(aday);
            days = optiondays.join(',');
        }
        me.form.holidays = days;
        me.form.holidayOptions = optiondays;
      }else{
        var aday = me.form.arestday;
        var days = me.form.restdays;
        var optiondays = me.form.restdayOptions;
        if(!days){
            days = aday;
            optiondays=[aday];
        }else if(days.indexOf(aday)==-1){
            optiondays.push(aday);
            days = optiondays.join(',');
        }
        me.form.restdays = days;
        me.form.restdayOptions = optiondays;
      }
    },
    delDay(type){
      var me = this;
      if(type=='holiday'){
        var ddayIndex = me.form.dholidayIndex;
        var days = me.form.holidays;
        var optiondays = me.form.holidayOptions;
        optiondays.splice(ddayIndex, 1);
        days = optiondays.join(',');
        me.form.dholidayIndex='';
        me.form.holidays=days;
        me.form.holidayOptions=optiondays;
      }else{
        var ddayIndex = me.form.drestdayIndex;
        var days = me.form.restdays;
        var optiondays = me.form.restdayOptions;
        optiondays.splice(ddayIndex, 1);
        days = optiondays.join(',');
        me.form.drestdayIndex='';
        me.form.restdays=days;
        me.form.restdayOptions=optiondays;
      }
    },
    add(){
        var me=this;
        me.resetForm();
        // me.form.unitId = this.expUser.dep.loginUnit.id;
        // me.form.unitName = this.expUser.dep.loginUnit.name;
        me.title='新增';
        me.isNew = true;
        this.mwRef('dialog').show();
    },
    edit(row,index) {
      let me=this;
      this.mwApi.data.getWorkTime(row.id).then(res => {
        if (res.success) {
          var data = res.result;
          me.resetForm();
          me.form.id=data.id;
          me.form.unitId=data.unitId;
          me.form.unitName=data.unitName;
          var amTimes = data.amTime.split('-');
          me.form.amStartTime=amTimes[0];
          me.form.amEndTime=amTimes[1];
          var pmTimes = data.pmTime.split('-');
          me.form.pmStartTime=pmTimes[0];
          me.form.pmEndTime=pmTimes[1];
          me.form.workdaysList = data.workdays.split(',');
          me.form.holidays = data.holidays;
          me.form.restdays = data.restdays;
          if(data.holidays){
            me.form.holidayOptions=data.holidays.split(',');
          }
          if(data.restdays){
            me.form.restdayOptions=data.restdays.split(',');
          }
          me.title='编辑-'+me.form.unitName+'工作时间';
          me.mwRef('dialog').show();
        }
      });
    },
    delete(data){
      let me=this;
      if(data.length==0){
        me.mwMsg("info","请至少选择一条记录！");
        return;
      }
      me.mwConfirm('删除后将无法恢复，您确定要删除所选记录? ').then(() => {
        let ids=[];
        data.forEach(function(d){
          ids.push(d.id);
        })
        me.mwApi.data.deleteWorkTime(ids).then(res => {
          if (res.success) {
            me.mwMsg("删除成功");
            me.mwRef('toolbarTable').refreshTable();
          } else {
            me.mwMsg('warning','删除失败');
          }
        })
      }).catch(() => {});
    },
    setDefault(data){
      let me=this;
      if(data.length==0){
        me.mwMsg("info","请至少选择一条记录！");
        return;
      }
      if(data.length>1){
        me.mwMsg("info","只能选择一条记录！");
        return;
      }
      me.mwConfirm('您确定要把所选记录设置为默认').then(() => {
        let ids=[];
        data.forEach(function(d){
          ids.push(d.id);
        })
        me.mwApi.data.setDefaultWorkTime(ids[0]).then(res => {
          if (res.success) {
            me.mwMsg("设置成功");
            me.mwRef('toolbarTable').refreshTable();
          } else {
            me.mwMsg('warning','设置失败');
          }
        })
      }).catch(() => {});
    },
    save(){
      var me=this;
      var data={};
      if(me.form.id!=''){
        data.id=me.form.id;
      }
      if(me.form.unitName==''){
        me.mwMsg("info","请选择所属单位！");
        return;
      }
      if (!data.id) {
          me.mwApi.data.listWorkTime({titleColName:'unitName',unitId:me.defaultParams.parentId}).then((res)=>{
            if (res.result) {
              const addUnit = _.filter(res.result, item=>item.unitId == me.form.unitId);
              if (addUnit && addUnit.length > 0) {
                me.mwConfirm('当前所属单位已经存在工作时间,继续操作将覆盖原有工作时间,您确定要继续吗?').then(()=>{
                  data.id = addUnit[0].id;
                  me.saveWorkTime(data);
                });
              } else {
                me.saveWorkTime(data);
              }
            }
          });
      } else {
        me.saveWorkTime(data);
      }
    },
    saveWorkTime(params) {
      var me = this;
      var data = {};
      _.extend(data, params);
      data.unitId=me.form.unitId;
      data.unitName=me.form.unitName;
      data.amTime=me.form.amStartTime+'-'+me.form.amEndTime;
      data.pmTime=me.form.pmStartTime+'-'+me.form.pmEndTime;
      data.workdays=me.form.workdaysList.join(',');
      data.holidays=me.form.holidays;
      data.restdays=me.form.restdays;
      data.isDefault=me.form.isDefault;
      me.mwApi.data.saveWorkTime(data).then((res)=>{
        me.mwMsg("保存成功！");
        me.mwRef('dialog').hide();
        me.mwRef('toolbarTable').refreshTable();
      });
    },
    resetForm(){
      var me=this;
      me.form.id='';
      me.form.unitId='';
      me.form.unitName='';
      me.form.amStartTime='09:00';
      me.form.amEndTime='12:00';
      me.form.pmStartTime='13:30';
      me.form.pmEndTime='17:30';
      me.form.workdaysList=['1','2','3','4','5'];
      me.form.holidays='';
      me.form.restdays='';
      me.form.aholiday='';
      me.form.dholidayIndex='';
      me.form.holidayOptions=[];
      me.form.arestday='';
      me.form.drestdayIndex='';
      me.form.restdayOptions=[];
      me.form.isDefault=0;
    },
    handleClose(){
      let me = this;
      me.resetForm();
      me.isNew = false;
      this.mwRef("dialog").hide();
    },
    contains(arrays, obj) {
      var i = arrays.length;
      while (i--) {
        if (arrays[i] === obj) {
          return i;
        }
      }
      return -1;
    },
    setSpecialDay(date){
      let type = '';
      // 判断当前日期几, 是否工作日
      let dd = new Date(date).getDay();
      const dmd = date.substr(5,5);
      let holidays = this.form.holidays ? this.form.holidays.split(',') : [];
      let restdays = this.form.restdays ? this.form.restdays.split(',') : [];
      if ($.inArray(dd.toString(), this.form.workdaysList) !== -1) { // 是工作日
        const dayInHolidaysIndex = this.contains(holidays, dmd);
        if (dayInHolidaysIndex < 0) { // 判断节假日里面有没有当前日期, 没有说明当前日期正常上班
          holidays.push(dmd); // 将其设为节假日
          type = 'remove';
        } else {  // 节假日内有该日期, 说明当天放假
          holidays.splice(dayInHolidaysIndex, 1); // 设为工作日, 从节假日内移除该日期
          type = 'add';
        }
        this.form.holidays = holidays.join(',');
      } else {  // 不是工作日
        const dayInRestdaysIndex = this.contains(restdays, dmd);
        if (dayInRestdaysIndex < 0) { // 判断休息日上班里面有没有当前日期, 没有说明当前日期正常休息
          restdays.push(dmd); // 设为工作日
          type = 'add';
        } else {  // 休息日上班内有该日期, 说明当天上班
          restdays.splice(dayInRestdaysIndex, 1); // 设为正常休息日, 从休息日上班内移除该日期
          type = 'remove';
        }
        this.form.restdays = restdays.join(',');
      }
      this.$refs.worktimePreview.updateWorkDayState(date, type);
    },
    helpnotes(){
      PF.showHelp({url:'/helpDoc/platform/worktime.md'});
    },
    helpnotesview(){
      PF.showHelp({url:'/helpDoc/platform/worktimeView.md'});
    }
  },
  components: {
    worktimePreview
  }
}
</script>
<style>
.worktime-help pre p {
  line-height: 1;
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/modules/index/views/systemSet/set/worktime.vue